import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row justify-center q-pb-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createBlock(_component_general_dialog, {
        modelValue: _ctx.showDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showDialog) = $event))
    }, {
        card: _withCtx(() => [
            _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_q_icon, {
                                    name: "check_circle",
                                    color: "positive",
                                    size: "3rem"
                                })
                            ]),
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row text-center text-body2" }, " A validation email has been sent to your account. Please follow instructions in the email to validate your account. The link will expire in 24 hours ", -1))
                        ]),
                        _: 1,
                        __: [1]
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
